import PageLoader from "./page_loader";
import Debugger from "./console/debugger";
import EventBus from "./event_bus";
import { BOOK_TYPE, BOOK_TYPE_MAP } from "./book_define/book_type";
import { store } from "../store";
import PainterProxy from "./painter/proxy";
import { TURN_PAGE_TYPE } from './book_define/turn_page_type';

export default class PageControl {
    bookContents = new Map();
    studyContents = new Map();
    resourceContents = new Map();

    bookDirectoryMap = new Map();
    studyDirectoryMap = new Map();
    resourceDirectoryMap = new Map();

    /** @type {PageLoader} */
    pageLoader = new PageLoader();

    onFinishGoPage = null;

    //directoryContent = null;

    /**
     * Creates an instance of PageControl.
     * @param {PageLoader} loader
     * @memberof PageControl
     */
    constructor(loader) {
        this.pageLoader = loader;
    }

    setBookData(content) {
        let i = 0;

        let bookContents = content.book;
        for (i = 0; i < bookContents.length; i++) {
            this.bookContents.set(i, {files: bookContents[i].files, pageNames:bookContents[i].pageName.split("/")});
            this.setDirectoryMap(bookContents, this.bookDirectoryMap, i);
        }

        let studyContents = content.study;
        for (i = 0; i < studyContents.length; i++) {
            this.studyContents.set(i, {files: studyContents[i].files, pageNames: studyContents[i].pageName.split("/")});
            this.setDirectoryMap(studyContents, this.studyDirectoryMap, i);
        }

        let resourceContents = content.resource;
        for (i = 0; i < resourceContents.length; i++) {
            this.resourceContents.set(i, {files: resourceContents[i].files, pageNames: resourceContents[i].pageName.split("/")});
            this.setDirectoryMap(resourceContents, this.resourceDirectoryMap, i);
        }

        console.log("map:", this.bookDirectoryMap);

        Debugger.Instance.log({ "book content": this.bookContents }, "page_control");
        Debugger.Instance.log({ "study content": this.studyContents }, "page_control");
        Debugger.Instance.log({ "resource content": this.resourceContents }, "page_control");

    }

    setDirectoryMap(contents, map, index) {
        map.set(contents[index].pageName, {pageIndex: index, singleIndex: 0});
        const pageNames = contents[index].pageName.split("/");
        console.log("turnpageType::", store.turnPageType);
        if (pageNames.length > 1) {
            for(let i = 0; i < 2; i ++) {
                const pageName = pageNames[i];
                map.set(pageName, {pageIndex: index, singleIndex: i});
            }
        }
    }

    get getNowPages() {
        let pageFileNames;
        switch (store.nowBook) {
            case BOOK_TYPE.BOOK:
                pageFileNames = this.bookContents.get(store.nowPage).files;
                break;
            case BOOK_TYPE.STUDY:
                pageFileNames = this.studyContents.get(store.nowPage).files;
                break;
            case BOOK_TYPE.RESOURCE:
                pageFileNames = this.resourceContents.get(store.nowPage).files;
                break;
        }

        return pageFileNames;
    }

    getPages(page) {
        switch (store.nowBook) {
            case BOOK_TYPE.BOOK:
                return this.bookContents.get(page).files;
            case BOOK_TYPE.STUDY:
                return this.studyContents.get(page).files;
            case BOOK_TYPE.RESOURCE:
                return this.resourceContents.get(page).files;
        }
    }

    /**
     *
     * 
     * @param {*} page
     * @param {String} bookType 1: 課本, 2: 習作, 3: 周邊資源
     * @memberof PageControl
     */
    gotoPage(page, bookType = store.nowBook) {
        if (page == store.nowPage && bookType == store.nowBook) {
            // if (page == 0) {
            //     EventBus.getInstance().getAppRefs().alertDialog.showDialog("提示！", "已是第一頁", () => { });
            // } else if (page == store.pageContent[bookType].length - 1) {
            //     EventBus.getInstance().getAppRefs().alertDialog.showDialog("提示！", "已是最後一頁", () => { });
            // }
            // return;

            EventBus.getInstance().getAppRefs().directory.show = false;

            if (page == 0 || page == store.pageContent[bookType].length - 1) {
                return;
            }
        }
        if (!store.canTurnPage) {
            return;
        }

        store.canTurnPage = false;
        this.doChangePage();
        this.beforeGoPage();
        store.nowBook = BOOK_TYPE_MAP.get(bookType);

        Debugger.Instance.log({ nowBookType: store.nowBook }, "page_control");


        store.setNowPage(page);

        this.pageLoader.loadNewPage(this.getPages(page));
        if (store.singlePageMode) {
            if (store.turnPageType == TURN_PAGE_TYPE.TURN_RIGHT) {
                EventBus.getInstance().getAppRefs().bookPage.zoomCornerLeftTop();
            } else {
                EventBus.getInstance().getAppRefs().bookPage.zoomCornerRightTop();
            }
        } else {
            EventBus.getInstance().getAppRefs().bookPage.zoomNormal();
        }

        const currPaintSave = PainterProxy.getInstance().getMainPainterSave(store.currentPaintSaveKey);
        if (currPaintSave) {
            PainterProxy.getInstance().loadMainPainter(currPaintSave);

            // 若有載入存檔，載入完畢後重新初始化紀錄
            PainterProxy.getInstance().getMainPainter().painter.onFinishLoadSave = () => {
                PainterProxy.getInstance().initHistory();
            }
        }

        if (typeof this.onFinishGoPage == 'function') {
            this.onFinishGoPage();
        }
    }

    /**
     * 取得當前書本的下一頁
     *
     * @readonly
     * @memberof PageControl
     */
    get nextPage() {
        let newPage = store.nowPage + 1;

        if (store.nowBook == BOOK_TYPE.BOOK) {
            newPage = Math.min(newPage, this.bookContents.size - 1);
        } else if (store.nowBook == BOOK_TYPE.STUDY) {
            newPage = Math.min(newPage, this.studyContents.size - 1);
        } else if (store.nowBook == BOOK_TYPE.RESOURCE) {
            newPage = Math.min(newPage, this.resourceContents.size - 1);
        }

        return newPage;
    }

    /**
     * 取得當前書本的上一頁
     *
     * @readonly
     * @memberof PageControl
     */
    get prevPage() {
        let newPage = store.nowPage - 1;
        newPage = Math.max(newPage, 0);

        return newPage;
    }

    /**
     * 依照頁碼取得index
     *
     * @param {String} pageName 頁碼
     * @return {Number} index
     * @memberof PageControl
     */
    getPageIndexByName(pageName) {
        let directory = store.pageContent[store.nowBook];
        console.log(directory);
        let i = 0;
        for (i = 0; i < directory.length; i++) {
            if (directory[i].pageName.includes(pageName)) {
                return i;
            }
        }

        return -1;
    }

    /**
     * 前往指定的頁碼
     *
     * @param {String} pageName
     * @memberof PageControl
     */
    gotoPageByName(pageName, bookType = store.nowBook) {
        //store.nowBook = BOOK_TYPE_MAP.get(bookType);
        // let index = this.getPageIndexByName(pageName);
        let page = this.getPageByDirectoryName(pageName, bookType);

        if(page == null) {
            let index = this.getPageIndexByName(pageName);

            if(index === -1) {
                return;
            }

            page = {
                pageIndex: index,
                singleIndex: 0
            }
        }
        

        const index = page.pageIndex;
        store.setSinglePageIndex(page.singleIndex);

        
        if(store.nowPage == index) {
            if (store.singlePageMode) {
                if (store.turnPageType == TURN_PAGE_TYPE.TURN_RIGHT) {
                    EventBus.getInstance().getAppRefs().bookPage.zoomCornerLeftTop();
                } else {
                    EventBus.getInstance().getAppRefs().bookPage.zoomCornerRightTop();
                }
            }
        }else {
            this.gotoPage(page.pageIndex, bookType);
        }

        return store.pageContent[store.nowBook][index].pageName;
    }

    getPageByDirectoryName(pageName, bookType) {
        let page;
        let map;
        const book = BOOK_TYPE_MAP.get(bookType)
        if (book == BOOK_TYPE.BOOK) {
            map = this.bookDirectoryMap;
        } else if (book == BOOK_TYPE.STUDY) {
            map = this.studyDirectoryMap;
        } else if (book == BOOK_TYPE.RESOURCE) {
            map = this.resourceDirectoryMap;
        }

        if(map.has(pageName)) {
            page = map.get(pageName);
            return page;
        }else {
            return null;
        }

        
    }

    beforeGoPage() {
        const proxy = PainterProxy.getInstance();

        proxy.getCurrentPainter().painter.canvas.discardActiveObject();
        proxy.clearExceptTarget();
        proxy.saveMainPainter(store.currentPaintSaveKey);
        proxy.clearAll(false, false);

        EventBus.getInstance()._bookPage.$refs.ruler.switchRuler(false);

        EventBus.getInstance().getAppRefs().bookPage.clearLoadingAnim();

        EventBus.getInstance().getAppRefs().polygonCreater.show = false;
    }

    doChangePage() {
        const proxy = PainterProxy.getInstance();

        window.aFileControl.clearAfiles();
        proxy.initHistory();
    }

    getNowPageNames() {
        let map;
        if (store.nowBook == BOOK_TYPE.BOOK) {
            map = this.bookContents;
        } else if (store.nowBook == BOOK_TYPE.STUDY) {
            map = this.studyContents;
        } else if (store.nowBook == BOOK_TYPE.RESOURCE) {
            map = this.resourceContents;
        }

        return map.get(store.nowPage).pageNames;
    }
}